// TextRecommendationResult

const goToEditComment = (state) => {
  return {
    ...state,
    recStatus: "rec"
  }
}

export default goToEditComment